import type { AxiosResponse } from 'axios';

import api from '@/utils/axiosInterceptor';
import type {
  IEmployeeCustomerMap,
  IEmployeeCustomerMapDetailed,
  IAreaCustomerMap,
  IClientCustomerMap,
  IApiResponse,
} from '../types';

export interface ICreateEmployeeCustomerMapDto {
  employee: string;
  clients?: number[];
  areas?: number[];
  excludeClients?: number[];
  isFullAccess?: boolean;
}

export async function getEmployeesApi(): Promise<
  IApiResponse<IEmployeeCustomerMap[]>
> {
  const response: AxiosResponse<IApiResponse<IEmployeeCustomerMap[]>> =
    await api.get('/employee-customer-map/employees');
  return response.data;
}

export async function getAreasApi(): Promise<IApiResponse<IAreaCustomerMap[]>> {
  const response: AxiosResponse<IApiResponse<IAreaCustomerMap[]>> =
    await api.get('/employee-customer-map/areas');
  return response.data;
}

export async function getClientsApi(): Promise<
  IApiResponse<IClientCustomerMap[]>
> {
  const response: AxiosResponse<IApiResponse<IClientCustomerMap[]>> =
    await api.get('/employee-customer-map/clients');
  return response.data;
}

export async function getEmployeeDetailsApi(
  employeeId: string,
): Promise<IApiResponse<IEmployeeCustomerMapDetailed>> {
  try {
    const response: AxiosResponse<IApiResponse<IEmployeeCustomerMapDetailed>> =
      await api.get(`/employee-customer-map/employees/${employeeId}`);
    return response.data;
  } catch (error: any) {
    console.error('Error fetching employee details:', error);
    throw error;
  }
}

export async function createEmployeeCustomerMapApi(
  data: ICreateEmployeeCustomerMapDto,
): Promise<IApiResponse<unknown>> {
  const response: AxiosResponse<IApiResponse<unknown>> = await api.post(
    '/employee-customer-map',
    data,
  );
  return response.data;
}

export async function updateEmployeeCustomerMapApi(
  employeeId: string,
  data: ICreateEmployeeCustomerMapDto,
): Promise<IApiResponse<unknown>> {
  const response: AxiosResponse<IApiResponse<unknown>> = await api.put(
    `/employee-customer-map/${employeeId}`,
    data,
  );
  return response.data;
}
